export default __webpack_public_path__ + "static/media/CM.b3faacc2.svg";